import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CacheService } from 'src/app/services/cache.service';
import { DIMBO_CONSTANT } from 'src/app/utils/constant';

export interface DialogData {
  message: string;
  type: 'error' | 'confirm';
}


/** Error/confirm dialog; returns boolean. BrandCare title may come from cache. */
/** Dialog title (cached override). */
/** Constructor: inject deps + load cached title. */
/** Load cached title or fallback. */
/** Close with affirmative (true). */
/** Close with cancel (false). */
@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent  {
  brandCareTitle: string = DIMBO_CONSTANT.BRAND_CARE_TITLE;

  constructor(
     public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private cacheService: CacheService
  ) { this.setBrandCareTitleFromCache();}

  setBrandCareTitleFromCache() {
    const brandCareTitle = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRANDCARE_TITLE);
    this.brandCareTitle = brandCareTitle || DIMBO_CONSTANT.BRAND_CARE_TITLE;
  }

   onOk(): void {
    this.dialogRef.close(true); // true for both error OK and confirmation Yes
  }

  onCancel(): void {
    this.dialogRef.close(false); // false only for confirmation Cancel
  }

}
